function nunjucks_filter_date(dispatcher, i18n)
{
    this.name = 'date';
    this.filter = function(date, format, lang)
    {
        if (date instanceof Date) {
            return date.format(format||'Y-m-d H:i:s', lang);
        } else {
            return date;
        }
    };
    
    dispatcher.addListener('i18n.lang_change', function(new_lang){
        Date.format.lang = new_lang;
    });
    
    Date.format.lang = i18n.lang;
}